module.exports = __webpack_public_path__ + "img/BANDEAU_RETOUR.db77d14e.svg";